import React from 'react';
import styled from 'styled-components';
import Alert from 'gatsby-theme-core/src/components/alert';

const SuccessAlert = (props) => (
  <Alert {...props} $success>
    Het formulier is verstuurd, we nemen zo snel mogelijk contact met u op.
  </Alert>
);

export default styled(SuccessAlert)``;
